import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cond from 'lodash/cond';
import { SuiContainer, SuiLabel } from '@splashthat/sui';
import Spacer from 'common/components/Spacer';
import FormLogicCondition from './FormLogicCondition';

import './FormLogicConditionSet.styl';

const AND = 'AND';
const BASE_CLASS_NAME = 'FormLogicConditionSet';
export const PROTECTED_QUESTION_MESSAGE = 'Conditions must apply to protected field questions.';
export const NON_PROTECTED_QUESTION_MESSAGE = 'Conditions must apply to non-protected field questions.';

export default class FormLogicConditionSet extends Component {
    static propTypes = {
        logicRules: PropTypes.array.isRequired,
        operandNodes: PropTypes.array.isRequired,
        removeFormLogicEffect: PropTypes.func.isRequired,
        updateFormLogicEffect: PropTypes.func.isRequired,
        formNodeWithLogicIsProtected: PropTypes.bool.isRequired,
    };

    handleChangeOperandLeft = (id, operandLeft, operandLeftType) => {
        this.props.updateFormLogicEffect({
            logicRuleId: id,
            updates: { operandLeft, operandLeftType },
        });
    };

    handleChangeOperator = (id, operator) => {
        this.props.updateFormLogicEffect({
            logicRuleId: id,
            updates: { operator },
        });
    };

    handleChangeOperandRight = (id, operandRight, operandRightType) => {
        this.props.updateFormLogicEffect({
            logicRuleId: id,
            updates: { operandRight, operandRightType },
        });
    };

    render() {
        const { logicRules = [], operandNodes = [], removeFormLogicEffect, formNodeWithLogicIsProtected } = this.props;

        if (!logicRules.length) {
            return null;
        }
        const someOperandNodesAreProtected = operandNodes?.some((node) => node.protected);

        const protectedFieldMessage = cond([
            [() => formNodeWithLogicIsProtected, () => PROTECTED_QUESTION_MESSAGE],
            [() => someOperandNodesAreProtected, () => NON_PROTECTED_QUESTION_MESSAGE],
            [() => true, () => null],
        ])();

        return (
            <SuiContainer className={BASE_CLASS_NAME} variation="flex-vertical flex-inherit">
                {formNodeWithLogicIsProtected || someOperandNodesAreProtected ? (
                    <SuiContainer
                        variation="flex-group flex-horizontal flex-inherit"
                        className={`${BASE_CLASS_NAME}__container`}
                    >
                        <SuiLabel>{protectedFieldMessage}</SuiLabel>
                        <Spacer />
                        <Spacer />
                    </SuiContainer>
                ) : null}
                {logicRules?.map((condition, index) => (
                    <SuiContainer
                        key={condition.id}
                        variation="flex-group flex-horizontal flex-inherit"
                        className={`${BASE_CLASS_NAME}__container`}
                    >
                        <SuiContainer className={`${BASE_CLASS_NAME}__conjunction`}>
                            {index > 0 ? AND : null}
                        </SuiContainer>

                        <SuiContainer className={`${BASE_CLASS_NAME}__operations`}>
                            <FormLogicCondition
                                {...condition}
                                operandNodes={operandNodes}
                                onChangeOperandLeft={this.handleChangeOperandLeft}
                                onChangeOperator={this.handleChangeOperator}
                                onChangeOperandRight={this.handleChangeOperandRight}
                                removeFormLogicEffect={removeFormLogicEffect}
                                formNodeWithLogicIsProtected={formNodeWithLogicIsProtected}
                            />
                        </SuiContainer>
                    </SuiContainer>
                ))}
            </SuiContainer>
        );
    }
}
